// HubSpot's documented default for the identification fields.
export const BLANK_IDENTIFICATION = ''

// Classes, not ids: `inlineEmbedSelector` takes any selector.
const BLOCK = 'customer-agent'

// QA selectors and Datadog action names, per the host app's component-attributes convention.
export const CLOSE_TEST_ID = 'customer-agent-close'
export const EXPAND_TEST_ID = 'customer-agent-expand'
export const CLOSE_ACTION_NAME = 'customer-agent-close-chat'
export const EXPAND_ACTION_NAME = 'customer-agent-expand-chat'

export const FRAME_CLASS = BLOCK
export const PANEL_CLASS = `${BLOCK}__panel`
export const CLOSE_CLASS = `${BLOCK}__close`
export const EXPAND_CLASS = `${BLOCK}__expand`

export const FRAME_SELECTOR = `.${FRAME_CLASS}`
export const PANEL_SELECTOR = `.${PANEL_CLASS}`
export const CLOSE_SELECTOR = `.${CLOSE_CLASS}`
export const EXPAND_SELECTOR = `.${EXPAND_CLASS}`

export const LOAD_REQUESTED_ATTRIBUTE = 'data-customer-agent-load-requested'
export const CLOSING_ATTRIBUTE = 'data-customer-agent-closing'
export const EXPANDED_ATTRIBUTE = 'data-customer-agent-expanded'

export const CLOSE_ANIMATION_TIMEOUT_MS = 400
